export default __webpack_public_path__ + "static/media/services_creatives.31780704.jpg";